module.exports = __webpack_public_path__ + "img/icon-hybrid.b13115fb.png";